/**
 * Giesswein TV-Spot Popup
 * Zeitraum: 01.04.2026 – 29.05.2026
 * Zeigt ein Popup ±15 Minuten rund um jeden TV-Spot.
 * CSS-Isolation via Shadow DOM – keine Beeinflussung durch Shop-Styles.
 *
 * EINBINDUNG IN SHOPIFY:
 * 1. Online Store → Themes → Edit Code
 * 2. In layout/theme.liquid vor </body> einfügen:
 *    <script src="{{ 'giesswein-popup.js' | asset_url }}" defer></script>
 * 3. Dieses File unter Assets hochladen.
 *
 * TESTMODUS: ?gw-popup=1 an die URL anhängen
 */

(function () {
  'use strict';

  /* =====================================================================
     KONFIGURATION
     ===================================================================== */
  var COUPON_CODE    = 'REGEN26';
  var WINDOW_MIN     = 15;
  var WINDOW_AFTER   = 30;
  var COOKIE_NAME    = 'gw_popup';
  var COOKIE_HOURS   = 1;
  var TIMEZONE       = 'Europe/Vienna';
  var UMBRELLA_URL   = 'https://www.giesswein.com/products/umbrella?color=schwarz-022&variant=56623765029195';

  /* =====================================================================
     TV-SPOT ZEITPLAN  [Jahr, Monat(0-basiert), Tag, Stunde, Minute]
     ===================================================================== */
  var SPOTS = [
    [2026,3,1,18,55],[2026,3,2,19,18],[2026,3,4,19,22],[2026,3,7,19,22],
    [2026,3,8,18,25],[2026,3,9,19,18],[2026,3,10,18,2],[2026,3,11,18,55],
    [2026,3,11,19,22],[2026,3,13,19,18],[2026,3,14,19,10],[2026,3,15,18,55],
    [2026,3,16,18,25],[2026,3,16,19,22],[2026,3,17,18,55],[2026,3,18,19,22],
    [2026,3,20,18,55],[2026,3,21,19,22],[2026,3,22,19,18],[2026,3,23,19,18],
    [2026,3,23,19,50],[2026,3,24,18,55],[2026,3,25,19,22],[2026,3,27,19,18],
    [2026,3,28,19,22],[2026,3,29,19,18],[2026,3,30,19,22],[2026,4,2,19,50],
    [2026,4,4,19,18],[2026,4,5,19,50],[2026,4,6,18,25],[2026,4,7,19,18],
    [2026,4,8,18,25],[2026,4,9,19,22],[2026,4,11,19,18],[2026,4,12,19,22],
    [2026,4,13,19,18],[2026,4,15,18,55],[2026,4,16,19,18],[2026,4,16,19,50],
    [2026,4,18,19,18],[2026,4,19,19,22],[2026,4,20,18,25],[2026,4,21,19,18],
    [2026,4,22,18,55],[2026,4,23,19,22],[2026,4,26,19,50],[2026,4,27,19,18],
    [2026,4,28,19,22],[2026,4,29,18,55]
  ];

  /* =====================================================================
     HILFSFUNKTIONEN
     ===================================================================== */
  function spotToDate(s) {
    var iso = s[0] + '-' +
      String(s[1] + 1).padStart(2, '0') + '-' +
      String(s[2]).padStart(2, '0') + 'T' +
      String(s[3]).padStart(2, '0') + ':' +
      String(s[4]).padStart(2, '0') + ':00';
    var tempDate = new Date(iso + 'Z');
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: TIMEZONE,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    });
    var parts = {};
    formatter.formatToParts(tempDate).forEach(function (p) {
      parts[p.type] = p.value;
    });
    var zonedMs = new Date(
      parts.year + '-' + parts.month + '-' + parts.day + 'T' +
      parts.hour + ':' + parts.minute + ':' + parts.second + 'Z'
    ).getTime();
    var offsetMs = zonedMs - tempDate.getTime();
    return new Date(new Date(iso + 'Z').getTime() - offsetMs);
  }

  function setCookie(name, val, hours) {
    var d = new Date();
    d.setTime(d.getTime() + hours * 3600000);
    document.cookie = name + '=' + val + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function isTestMode() {
    try {
      return new URLSearchParams(window.location.search).get('gw-popup') === '1';
    } catch (e) { return false; }
  }

  function isInSpotWindow() {
    if (isTestMode()) return true;
    var now = Date.now();
    var wB = WINDOW_MIN * 60000;
    var wA = WINDOW_AFTER * 60000;
    for (var i = 0; i < SPOTS.length; i++) {
      var t = spotToDate(SPOTS[i]).getTime();
      if (now >= t - wB && now <= t + wA) return true;
    }
    return false;
  }

  /* =====================================================================
     SHADOW DOM STYLES  (vollständig isoliert von Shop-CSS)
     ===================================================================== */
  var SHADOW_CSS =
    ':host{' +
      'position:fixed!important;top:0!important;left:0!important;width:100%!important;height:100%!important;' +
      'z-index:999999!important;display:flex!important;align-items:center!important;justify-content:center!important;' +
      'background:rgba(0,0,0,.55)!important;' +
      'animation:gwFadeIn .3s ease;' +
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif!important;' +
      'font-size:16px!important;line-height:1.5!important;color:#1a1a1a!important;' +
      '-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;' +
    '}' +
    '*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif!important;line-height:inherit;}' +
    '@keyframes gwFadeIn{from{opacity:0}to{opacity:1}}' +
    '@keyframes gwSlideUp{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:translateY(0)}}' +

    '.card{' +
      'background:#fff;border-radius:16px;padding:40px 36px 32px;' +
      'max-width:460px;width:92%;text-align:center;position:relative;' +
      'box-shadow:0 24px 80px rgba(0,0,0,.25);' +
      'animation:gwSlideUp .4s ease .05s both;' +
    '}' +

    '.close{' +
      'position:absolute;top:12px;right:16px;background:none;border:none;' +
      'font-size:24px;color:#aaa;cursor:pointer;line-height:1;padding:4px 6px;' +
      'transition:color .2s;' +
    '}' +
    '.close:hover{color:#333;}' +

    '.badge{' +
      'display:inline-block;background:#e8192c;color:#fff;' +
      'font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;' +
      'padding:5px 14px;border-radius:20px;margin-bottom:18px;' +
    '}' +

    'h2{font-size:20px;font-weight:600;color:#1a1a1a;line-height:1.4;margin-bottom:10px;}' +

    '.desc{font-size:15px;color:#555;line-height:1.6;margin-bottom:20px;}' +

    '.coupon-box{' +
      'display:inline-flex;align-items:center;gap:10px;' +
      'background:#f5f5f5;border:2px dashed #ccc;border-radius:10px;' +
      'padding:12px 20px;cursor:pointer;transition:all .2s;' +
    '}' +
    '.coupon-box:hover{border-color:#e8192c;background:#fef5f5;}' +
    '.coupon-code{font-size:22px;font-weight:700;color:#e8192c;letter-spacing:2px;}' +
    '.coupon-hint{font-size:12px;color:#999;white-space:nowrap;}' +

    '.copied-msg{height:22px;margin-top:6px;font-size:13px;color:#2eab5e;font-weight:600;animation:gwFadeIn .2s ease;}' +

    '.divider{border:none;border-top:1px solid #eee;margin:20px 0 18px;}' +

    '.gift{' +
      'display:flex;align-items:center;gap:16px;' +
      'background:#f8faf8;border:1px solid #e0e8e0;border-radius:12px;' +
      'padding:14px 16px;text-align:left;' +
    '}' +
    '.gift-img{' +
      'flex-shrink:0;width:72px;height:72px;' +
      'border-radius:10px;object-fit:cover;' +
      'border:1px solid #e0e8e0;' +
    '}' +
    '.gift-text{font-size:13.5px;color:#333;line-height:1.5;}' +
    '.gift-text strong{font-weight:700;color:#1a1a1a;}' +
    '.gift-link{color:#e8192c;text-decoration:underline;text-underline-offset:2px;font-weight:600;transition:color .2s;}' +
    '.gift-link:hover{color:#b71420;}' +

    '.conditions{font-size:11.5px;color:#999;line-height:1.5;margin-top:16px;text-align:center;}';

  /* =====================================================================
     POPUP HTML
     ===================================================================== */
  var SHADOW_HTML =
    '<div class="card">' +
      '<button class="close" data-action="close" aria-label="Schlie\u00dfen">\u00d7</button>' +
      '<div class="badge">ZDF Aktion</div>' +
      '<h2>Liebe ZDF Zuseher</h2>' +
      '<p class="desc">Wir feiern unseren TV-Spot und schenken dir einen Giesswein Regenschirm! Sichere dir jetzt deinen Gutscheincode:</p>' +
      '<div class="coupon-box" data-action="copy" title="Code kopieren">' +
        '<span class="coupon-code">' + COUPON_CODE + '</span>' +
        '<span class="coupon-hint">Kopieren</span>' +
      '</div>' +
      '<div class="copied-msg" data-ref="copied"></div>' +
      '<hr class="divider">' +
      '<div class="gift">' +
        '<img class="gift-img" src="https://www.giesswein.com/cdn/shop/files/84-90-25272-022_1_1250x.progressive.jpg?v=1771992422" alt="Giesswein Regenschirm" loading="lazy">' +
        '<div class="gift-text">' +
          '<strong>Gratis Regenschirm</strong> zu deiner Bestellung!<br>' +
          'F\u00fcge den ' +
          '<a class="gift-link" href="' + UMBRELLA_URL + '" target="_blank" rel="noopener">' +
            'Giesswein Regenschirm' +
          '</a> zu deinem Warenkorb hinzu \u2013 bei Anwendung des Codes wird er gratis.' +
        '</div>' +
      '</div>' +
      '<p class="conditions">' +
        'Max. 1 Gratis-Regenschirm pro Bestellung. Nur in Verbindung mit einem regul\u00e4ren Produkt einl\u00f6sbar. ' +
        'Nicht mit anderen Aktionen kombinierbar. G\u00fcltig bis 31.05.2026 bzw. solange der Vorrat reicht.' +
      '</p>' +
    '</div>';

  /* =====================================================================
     POPUP LIFECYCLE
     ===================================================================== */
  var hostEl = null;

  function showPopup() {
    if (!isTestMode() && getCookie(COOKIE_NAME)) return;
    if (hostEl && document.body.contains(hostEl)) return;

    // Host-Element mit minimalem Inline-Style (nur was :host nicht absichern kann)
    hostEl = document.createElement('div');
    hostEl.id = 'gw-popup';
    hostEl.style.cssText = 'all:initial;position:fixed;top:0;left:0;width:100%;height:100%;z-index:999999;';
    hostEl.setAttribute('role', 'dialog');
    hostEl.setAttribute('aria-modal', 'true');
    hostEl.setAttribute('aria-label', 'Gutschein Aktion');

    // Shadow DOM kapselt alle Styles
    var shadow = hostEl.attachShadow({ mode: 'open' });
    shadow.innerHTML = '<style>' + SHADOW_CSS + '</style>' + SHADOW_HTML;

    // Event-Delegation innerhalb Shadow DOM
    shadow.addEventListener('click', function (e) {
      var target = e.target;
      var actionEl = target.closest ? target.closest('[data-action]') : null;
      var action = (target.dataset && target.dataset.action) || (actionEl && actionEl.dataset.action);

      if (action === 'close') { closePopup(); return; }
      if (action === 'copy') { copyCode(shadow); return; }
    });

    document.body.appendChild(hostEl);
  }

  function closePopup() {
    if (!hostEl) return;
    hostEl.style.opacity = '0';
    hostEl.style.transition = 'opacity .2s ease';
    setTimeout(function () {
      if (hostEl && hostEl.parentNode) hostEl.parentNode.removeChild(hostEl);
      hostEl = null;
    }, 200);
    setCookie(COOKIE_NAME, '1', COOKIE_HOURS);
  }

  function copyCode(shadow) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(COUPON_CODE);
    } else {
      var ta = document.createElement('textarea');
      ta.value = COUPON_CODE;
      ta.style.cssText = 'position:fixed;opacity:0;';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    var msg = shadow.querySelector('[data-ref="copied"]');
    if (msg) msg.textContent = '\u2713 Code kopiert!';
  }

  /* =====================================================================
     INITIALISIERUNG
     ===================================================================== */
  function checkAndShow() {
    if (isTestMode()) console.log('[GW-Popup] Testmodus aktiv \u2013 Popup wird erzwungen');
    if (isInSpotWindow()) showPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndShow);
  } else {
    checkAndShow();
  }
  setInterval(checkAndShow, 30000);

})();